import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('LeagueDivision')
export class LeagueDivision {

  @JsonProperty('division_id', Number)
  divisionId: number = 0;

  @JsonProperty('league_id', Number)
  leagueId: number = 0;

  @JsonProperty('league_tier', Number)
  leagueTier: number = 0;

  @JsonProperty('end_date_timestamp', Number)
  endDateTimestamp: number = 0;

  @JsonProperty('users_count', Number)
  usersCount: number = 0;
}
